export const PATIENT_TYPE = { InSystem: "MEDINAV", Guest: "GUEST" };
